<template>
    <div style="height:480px">
        <el-steps :active="active" align-center v-if="isflow" finish-status="success">
            <el-step title="上传文件" />
            <el-step title="预览数据" />
            <el-step title="配置表单" />
            <el-step title="配置导入参数" />
            <el-step title="导入结果" />
        </el-steps>
        <el-steps :active="active" align-center v-else finish-status="success">
            <el-step title="上传文件" />
            <el-step title="预览数据" />
            <el-step title="配置表单" />
            <el-step title="导入结果" />
        </el-steps>

        <div class="bz1" v-show="active == importStep.Upload">
            <div class="import-mode">
                <span>导入模式：</span>
                <el-select :model-value="importMode" @change="changeImportMode">
                    <el-option v-for="item in importModeOptions"
                        :value="item.value"
                        :label="item.text">
                    </el-option>
                </el-select>

                <span v-if="updateMode" style="margin-left: 20px;">
                    <span>匹配模式：</span>
                    <el-select v-model="updateQueryMode" :disabled="updateQueryModeDisable">
                        <el-option v-for="item in updateQueryModeOptions"
                            :value="item.value"
                            :label="item.text"
                            >
                        </el-option>
                    </el-select>
                </span>
            </div>
            <ul class="import-tip">
                <li>为保证数据导入顺利，推荐您使用<el-link type="primary" :href="templatePath" target="_blank">标准模板</el-link></li> 
                <li v-if="updateMode">当前导入模式包含更新数据操作，<span style="color:red">请确保第一列为主键或者数据Id</span></li> 
                <li><span>请仔细查看数据条目，避免出现导入数据缺失情况。如有必要建议粘贴复制数据至空白表格中导入</span></li> 
                <li><span>不能存在合并的单元格</span></li> 
                <li><span>支持 2MB 以内的xls、xlsx格式文件</span></li> 
                <li><span>仅支持导入第一个工作表的xls、xlsx文件</span></li>
            </ul>
            <el-upload
                name="files"
                :action="uploadUrl"
                :data="uploadData"
                :on-success="onSuccess"
                :on-error="onError"
                :before-upload="beforeAvatarUpload"
                class="import-upload"
                drag>
                <el-icon class="el-icon--upload"><upload-filled /></el-icon>
                <div class="el-upload__text">
                    将文件拖到此处或点击上传
                </div>
                <div class="el-upload__text">
                    <em>{{ fileName }}</em>
                </div>
            </el-upload>
        </div>
        <div class="bz2" v-show="active == importStep.Preview">
            <br/>
            <div class="el-alert el-alert--warning is-light" role="alert">
                <i class="el-icon el-alert__icon"><svg viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg"><path fill="currentColor" d="M512 64a448 448 0 1 1 0 896 448 448 0 0 1 0-896zm0 192a58.432 58.432 0 0 0-58.24 63.744l23.36 256.384a35.072 35.072 0 0 0 69.76 0l23.296-256.384A58.432 58.432 0 0 0 512 256zm0 512a51.2 51.2 0 1 0 0-102.4 51.2 51.2 0 0 0 0 102.4z"></path></svg></i>
                <div class="el-alert__content">
                    <span class="el-alert__title">
                        当前excel文件共计 <span class="line-height">{{ rowCount }}</span> 条数据
                    </span>
                </div>
                <div class="el-alert__content" style="margin-left: auto;">
                    <span class="el-alert__title">
                        点击任意一行可将其设置为标题行，标题行之前的数据不导入
                    </span>
                </div>
            </div>
            <br/>
            <el-table height="300"
                ref="table"
                v-loading="getDataLoading"
                element-loading-text="拼命解析数据中..."
                @current-change="changeRowIndex"
                highlight-current-row
                :data="tableData" 
                border 
                style="width: 100%">
                <el-table-column 
                    align="center"
                    width="150">
                    <template #default="scope">
                        <div v-if="scope.row.index == currentIndex" class="titleCell"> 
                            标题行
                        </div>
                        <span v-else> {{ scope.row.index }}</span>
                    </template>
                </el-table-column>
                <el-table-column v-for="item in definitions" 
                    show-overflow-tooltip
                    align="center"
                    min-width="150" 
                    :prop="item.name" />
            </el-table>
            <div class="importButton">
                <el-button style="margin-left: 12px;" type="success" @click="active = importStep.ConfigData" :disabled="getDataLoading">下一步</el-button>
                <el-button @click="active = importStep.Upload">上一步</el-button>
            </div>
        </div>
        <div class="bz3" v-show="active == importStep.ConfigData">
            <br/>
            <el-alert :title="configDataAlertMessage" :type="configDataAlertType" :closable="false" show-icon/>
            <br/>
            <el-table height="300"
                :data="configDataTableData" 
                border 
                style="width: 100%">
                <el-table-column 
                    align="center"
                    width="150"
                    type="index"
                    :index="setIndex"
                    >
                    <template #header="scope">
                        表单字段
                    </template>
                </el-table-column>
                <el-table-column v-for="(item,columnIndex) in configDataTableHeader" 
                    align="center"
                    min-width="150" 
                    :prop="item.name" >
                    <template #header="scope">
                        <div class="displayName">
                            {{ item.tableHeaderName }}
                        </div>
                        <el-select filterable v-model="item.value" :disabled="item.disabled">
                            <el-option v-for="optionitem in item.configFieldOptions"
                                :key="optionitem.Name"
                                :value="optionitem.Name"
                                :label="optionitem.DisplayName">
                            </el-option>
                        </el-select>
                    </template>
                </el-table-column>
            </el-table>
            <div class="importButton">
                <el-button style="margin-left: 12px;" type="success" @click="active = importStep.ConfigFlow">下一步</el-button>
                <el-button @click="active = importStep.Preview">上一步</el-button>
            </div>
        </div>
        <div class="bz4" v-show="active == importStep.ConfigFlow && isflow">
            <div class="configFlow">
                <div>
                    <span>节点信息：</span>
                    <el-select v-model="currentNode" :disabled="flowConfigDisabled">
                        <el-option v-for="item in showNodes"
                            :value="item.Name"
                            :label="item.DisplayName">
                        </el-option>
                    </el-select>
                </div>
                <div>
                    <span>节点自动提交：</span>
                    <el-switch
                        :disabled="flowConfigDisabled"
                        v-model="needNodeHandler"
                        class="mt-2"
                        style="margin-left: 24px"
                        inline-prompt
                    />
                </div>
                <div v-if="onlyFlowUpdateData">
                    <span>忽略流程仅更新excel数据：</span>
                    <el-switch 
                        @change="onlyUpdateFuc"
                        :model-value="onlyUpdate"
                        class="mt-2"
                        style="margin-left: 24px"
                        inline-prompt
                    />
                </div>
            </div>
            <div class="importButton">
                <el-button style="margin-left: 12px;" type="success" @click="active = importStep.Result">下一步</el-button>
                <el-button @click="active = importStep.ConfigData">上一步</el-button>
            </div>
        </div>
        <div class="bz5" v-show="(active == importStep.Result && isflow) || (active == importStep.ConfigFlow && !isflow)">
            <el-result class="resultHeight"
                v-loading="loadingWaitResult"
                element-loading-text="拼命导入数据中..."
                :icon="resultIcon"
                title="操作完成">
                <template #extra>
                    <div>
                        <div v-if="newSuccess == 0 && updateSuccess == 0">数据导入失败</div>
                        <div v-if="newSuccess > 0">导入创建成功 {{ newSuccess }} 条</div>
                        <div v-if="updateSuccess > 0">导入更新成功 {{ updateSuccess }} 条</div>
                        <div v-if="fail > 0">导入失败<span style="color:red"> {{ fail }} </span>条</div>
                        <div v-if="fail > 0">详情见<el-link type="primary" :href="failExcelPath" target="_blank">错误</el-link></div>
                    </div>
                </template>
            </el-result>
            <div class="importButton">
                <el-button type="success" @click="finishImport">完成</el-button>
            </div>
        </div>
    </div>
</template>

<style>
    .bz5 .el-loading-mask{
        background-color: rgb(255, 255, 255) !important;
    }

    .line-height{
        font-weight: 700;
        color: red;
    }
    .floatRight{
        float: right;
    }
    .importButton{
        display: -webkit-flex; 
        display: flex;
        margin-top: 1rem;
        flex-direction: row-reverse;
    }


    .bz1 {
        padding: 10px 50px;
    }

    .bz1 .import-mode{
        padding: 10px 20px;
    }

    .bz1 .import-tip{
        margin: 0;
        height: 140px;
        padding: 30px 20px 15px 50px;
    }

    .bz1 .el-select{
        width: 220px;
    }

    .bz1 .el-upload-list.el-upload-list--text{
        display: none;
    }
    .import-upload .el-upload{
        width:100% !important
    }
    .import-upload .el-upload-dragger{
        width:100% !important
    }
    .bz2 .el-table__header-wrapper{
        display:none
    }
    .bz2 .current-row{
        font-weight: 600;
    }
    .bz2 .titleCell{
        position: relative;
        height: 24px;
        margin: 0rem 1.5rem;
        color: white;
        background-color: #0DB3A6;
    }
    .bz2 .titleCell::after{
        position: absolute;
        top: 0;
        right: -24px;
        bottom: 0;
        border: 12px solid transparent;
        border-left-color: #0db3a6;
        content: "";
    }

    .bz3 .displayName{
        margin: 0px -12px 8px;
        padding: 0 0 8px;
        border-bottom: 1px rgb(235, 238, 245) solid;
    }
   
    .bz4 .configFlow{
        height: 324px;
        padding-left: 30px;
        text-align: center;
        padding-top: 50px ;
    }
    .bz4 .configFlow>div{
        margin-bottom: 15px;
    }

    .bz5 .result{
        line-height: 1.5rem;
    }
    
    .bz5 .resultHeight{
        height: 380px;
    }
</style>
    
<script>
    import { UploadFilled } from '@element-plus/icons-vue'
    import { ElMessage } from 'element-plus';
    import { ImportMode, UpdateQueryMode, ImportStep, CreateFlowNodeSetting } from '.'
    import { ResponseCode } from '../../common/constant';
    import { MethodsUrl } from '../../apis';
    import { previewExcelData, initImportItem, importDataByExcel, superImportDataByExcel } from '../../apis/httpHelper'
    import QweNotify from "../QweNotify/QweNotify"; 	
    import { NotificationState, NotificationType } from '../Notification';
    import task from "../../utils/task";
    import { addReceiveMessageTask } from "../../utils/signalR/SignalR"
    
    addReceiveMessageTask((response)=>{
        if(response.notificationType == NotificationType.Excel){
            task.executeTask(response.requestId)
        }
    })

    export default {
        props:{
            fatchDataSource:Function,
            isSuperImport:{
                type:Boolean,
                default:function(){
                    return false;
                }
            },
            contentType:String,
            templatePath:String,
            activities:Array,
            parameters: {
                type: Array,
                default: function () {
                    return new Array();
                },
                validator: function (value) {
                    return value.filter(x => x.hasOwnProperty("FieldName") && x.hasOwnProperty("Value") && x.hasOwnProperty("UpdateMode")).length === value.length;
                }
            },
            node: {
                type: String,
                default: ""
            },
            mode: {
                type: String,
                default: "0",
                validator: function (value) {
                    return ['0', '1', '2'].indexOf(value) !== -1;
                }
            },
            modedisable: Boolean,
            nodedisable: Boolean
        },

        components:{
            'upload-filled':UploadFilled
        },

        emits:[
            "init",
            "finish",
            "closeimport"
        ],

        data:function(){
            return {
                active:ImportStep.Upload,
                isflow:false,
                importStep:ImportStep,

                //upload
                importMode:ImportMode.New,
                importModeOptions:[{
                    value:ImportMode.New,
                    text:"仅新增"
                },{
                    value:ImportMode.Update,
                    text:"仅更新"
                },{
                    value:ImportMode.UpdateAndNew,
                    text:"更新与新增"
                }],

                updateQueryMode:UpdateQueryMode.ContentItemId,
                updateQueryModeOptions:[{
                    value:UpdateQueryMode.ContentItemId,
                    text:"数据Id"
                },{
                    value:UpdateQueryMode.Primarykey,
                    text:"主键"
                }],

                uploadUrl:"",
                uploadData:{
                    
                },

                
                filePath: "",
                fileName: "",

                //preview
                definitions:[],
                tableData: [],
                currentIndex: 1,
                rowCount:0,
                getDataLoading:true,

                //configData
                totalColumnCount:0,
                configDataTableHeader: [],
                configDataTableData:[],

                configFieldOptions:[],
                configPrimaryKeyOptions:[],
                configPrimaryKey:"",

                //configFlow
                nodes: [], 
                showNodes:[],
                currentNode:"",

                //result
                loadingWaitResult:true,
                resultIcon:"warning",
                newSuccess: 0,
                updateSuccess: 0,
                fail: 0,
                failExcelPath:"",

                needNodeHandler: false,
                onlyUpdate:false,
                flowConfigDisabled:false
            }
        },

        created:function(){
            this.uploadData = {
                "__RequestVerificationToken":this.$store.state.requestVerificationToken,
                "path":"importExcel"
            };
            this.uploadUrl = this.$store.state.baseUrl + MethodsUrl.uploadFile;
            initImportItem(this.contentType).then(x=>{
                let result = x.Result;
                this.isflow = result.IsFlow;
                if(result.IsFlow){
                    this.importModeOptions = [{
                        value:ImportMode.New,
                        text:"仅新增"
                    },{
                        value:ImportMode.Update,
                        text:"仅更新"
                    }];
                }
                let PrimaryKeyfields = result.Fields.filter(x=> x.Type == "PrimaryKeyField");
                this.updateQueryModeDisable = PrimaryKeyfields.length == 0;
                this.configPrimaryKeyOptions = [{ "DisplayName" : "数据Id", "Name":"ContentItemId" }];
                if(!this.updateQueryModeDisable){
                    this.configPrimaryKeyOptions.push(PrimaryKeyfields[0]);
                    this.configPrimaryKey = PrimaryKeyfields[0].Name;
                }
                
                this.configFieldOptions = result.Fields;
                this.configFieldOptions.unshift({
                    DisplayName : "不导入",
                    Name:"NoImport"
                });
                
                this.nodes = result.Nodes;
                this.showNodes = result.Nodes;
                this.$emit("init",true)
            }).catch(x=>{
                this.$emit("init",false)
                console.log(x)
            })
        },

        computed:{
            showImportTemplate:function(){
                return (this.templatePath !=null || this.templatePath !=undefined) && this.templatePath.length > 0;
            },

            updateMode:function(){
                return this.importMode != ImportMode.New
            },

            importColumnCount:function(){
                return this.configDataTableHeader.filter(x=>x.value != "NoImport").length;
            },

            configDataAlertType:function(){
                return this.importColumnCount == this.totalColumnCount ? "success" : "warning";
            },

            configDataAlertMessage:function(){
                return "当前导入 " + this.importColumnCount+" 列 / 共计 "+ this.totalColumnCount + " 列";
            },

            onlyFlowUpdateData:function(){
                return this.importMode == ImportMode.Update
            },
        },

        watch:{
            active:function(to, from){
                if(to > from){
                    switch (to){
                        case ImportStep.Preview:
                            previewExcelData(this.filePath).then(x=>{
                                this.getDataLoading = false;
                                let tableData = new Array();
                                let definitions = new Array();
                                x.Result.DataItems.forEach((x,rowIndex)=>{
                                    let data = {
                                        index : rowIndex +1
                                    };
                                    x.forEach((y,index)=>{
                                        data["p"+index] = y.Value
                                    });
                                    tableData.push(data);
                                });
                                this.rowCount = x.Result.RowCount;
                                this.tableData = tableData;
                                x.Result.DataItems[0].forEach((y,cellindex)=>{
                                    definitions.push({ name:"p"+cellindex })
                                });
                                this.definitions = definitions;
                                this.totalColumnCount = x.Result.DataItems[0].length;
                                this.$refs.table.setCurrentRow(this.tableData[0]);
                            })
                            .catch(x=> { 
                                console.log(x); 
                                this.active = ImportStep.Upload;
                            })
                            break;
                        case ImportStep.ConfigData:
                            let configDataHeader = new Array();
                            let header = this.tableData[this.currentIndex - 1];
                            this.configDataTableData = this.tableData.slice(this.currentIndex);
                            this.definitions.forEach((x,index)=>{
                                configDataHeader.push({
                                    name : x.name,
                                    value : "NoImport",
                                    index: index,
                                    tableHeaderName : header[x.name],
                                    disabled:false,
                                    configFieldOptions:this.configFieldOptions
                                })
                            });
                            configDataHeader.forEach(x=>{
                                let result = this.configFieldOptions.find(y=> y.DisplayName == x.tableHeaderName);
                                if(result != undefined){
                                    x.value = result.Name;
                                }
                            });
                            if(this.updateMode){
                                configDataHeader[0].configFieldOptions = this.configPrimaryKeyOptions; 
                                configDataHeader[0].disabled = true;
                                if(this.updateQueryMode == UpdateQueryMode.ContentItemId){
                                    configDataHeader[0].value = "ContentItemId";
                                }
                                else{
                                    configDataHeader[0].value = this.configPrimaryKey;
                                }
                            }
                            this.configDataTableHeader = configDataHeader;
                            break;
                        case ImportStep.ConfigFlow:
                            if(!this.isflow){
                                this.importData();
                            }
                            else{
                                if(this.importMode == ImportMode.New){
                                    this.showNodes = this.nodes.filter(x=> ["StartNode", "EndNode"].includes(x.Type));
                                    this.currentNode = this.nodes.find(x=>x.Type == "StartNode").Name;
                                    this.needNodeHandler = true;
                                }
                            }
                            break;
                        case ImportStep.Result:
                            if(this.isflow){
                                this.importData();
                            }
                            break;
                    }
                }
                else{
                    switch (to){
                        case ImportStep.Upload:
                            this.getDataLoading = true;
                            break;
                    }
                }
            }
        },

        methods:{
            onSuccess:function(response){
                let code = response.Code;
                if(code == ResponseCode.Success){
                    this.filePath = response.Result[0].url;
                    this.fileName = response.Result[0].name;
                    this.active = ImportStep.Preview;
                }
                else{
                    response.ErrorMessages.forEach(element => {
                        setTimeout(() => {
                            ElMessage.error(element.ErrorMessage)
                        }, 50);
                    });
                }
            },

            onError:function(error){
                ElMessage.error("上传失败，请稍后再试，如遇多次问题请联系管理员");
                console.log(error);
            },

            beforeAvatarUpload:function(rawFile){
                let importTypes =[
                    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                    "application/vnd.ms-excel"
                ]
                if(importTypes.includes(rawFile.type)){
                    return true;
                }
                else{
                    ElMessage.error("当前文件格式不支持导入，请上传xls或者xlsx格式的文件")
                    return false;
                }
            },

            changeRowIndex:function(currentRow){
                this.currentIndex = currentRow.index;
            },

            setIndex:function(index){
                return index + 1;
            },

            importData:async function(){
                let importColumn = this.configDataTableHeader.map(x=>x.value);
                if(this.isflow && this.importMode == ImportMode.UpdateAndNew){
                    ElMessage.error("流程导入时不支持同时创建与更新，请分开创建数据与更新数据两次导入");
                    if(this.flow){
                        this.active = ImportStep.ConfigFlow;
                    }
                    else{
                        this.active = ImportStep.ConfigData;
                    }
                    return;
                }
                let importByExcel;
                if(this.isSuperImport){
                    importByExcel = superImportDataByExcel(
                        this.filePath,
                        this.contentType,
                        this.currentIndex,
                        this.importMode,
                        this.updateQueryMode,
                        importColumn,
                        CreateFlowNodeSetting.Start,
                        this.needNodeHandler,
                        JSON.stringify(this.parameters),
                        this.activities
                    ).then(response =>{
                        let taskId = response.Result;
                        QweNotify[NotificationState.Wait]({
                            title:"导入文件执行中...",
                            message:"正在将文件中的记录导入到您的系统中。请稍后。"
                        });
                        this.$emit("closeimport");
                        let self = this;
                        task.addTask(taskId,()=>{
                            self.fatchDataSource();
                        })
                    }).catch(x=>{
                        if(this.flow){
                            this.active = ImportStep.ConfigFlow;
                        }
                        else{
                            this.active = ImportStep.ConfigData;
                        }
                        console.log(x);
                    })
                }
                else{
                    importByExcel = importDataByExcel(
                        this.filePath,
                        this.contentType,
                        this.currentIndex,
                        this.importMode,
                        this.updateQueryMode,
                        importColumn,
                        CreateFlowNodeSetting.Start,
                        this.needNodeHandler,
                        JSON.stringify(this.parameters),
                        this.onlyUpdate,
                        this.currentNode
                    ).then(response =>{
                        let result = response.Result;
                        this.newSuccess = result.NewSuccess;
                        this.updateSuccess = result.UpdateSuccess;
                        this.fail = result.Fail; 
                        this.resultIcon = (result.Fail > 0 || (result.NewSuccess + result.UpdateSuccess) == 0)  ? "warning" : "success";
                        this.failExcelPath = result.FailImportExcel;
                        this.loadingWaitResult = false;
                    }).catch(x=>{
                        if(this.flow){
                            this.active = ImportStep.ConfigFlow;
                        }
                        else{
                            this.active = ImportStep.ConfigData;
                        }
                        console.log(x);
                    })
                }
            },

            finishImport:function(){
                this.$emit("finish");
            },

            onlyUpdateFuc:function(val){
                if(val){
                    this.flowConfigDisabled = true;
                    this.currentNode = "";
                    this.needNodeHandler = false;
                }
                else{
                    this.flowConfigDisabled = false;
                }
                this.onlyUpdate = val;
            },

            changeImportMode:function(val){
                //todo
                this.importMode = val;
            }
        }
    }
</script>